var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    zPaging: function () {
      return import(
        /* webpackChunkName: "uni_modules/z-paging/components/z-paging/z-paging" */ "@/uni_modules/z-paging/components/z-paging/z-paging.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.chapters, function (item, __i0__) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.questions.length
    var g1 = item.questions.length
    var g2 = g1 > 0 ? item.questions.length : null
    var g3 = g1 > 0 ? item.history.length : null
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
      g2: g2,
      g3: g3,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show = true
    }
    _vm.e1 = function ($event, index) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        index = _temp2.index
      var _temp, _temp2
      _vm.leftSelect = index
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }